import { User } from "../entities/User";

const BasketPolicy = {
  canAccess(user: User) {
    return true;
  }
}

export default BasketPolicy;
